import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const LoadingSpinner = () => {
    return (
        <div className="loading-spinners">
            <FontAwesomeIcon icon={faSpinner} spin />
        </div>
    );
};

export default LoadingSpinner;
